
var capoareaData = [];
var dealerData = {};
var orderData = {};


$(function(){
    customFields();
    cartInput();
    cart();
    orderlist();
    setDashboard();
    minQty();
    capoarea();
});

function capoarea(){
    $('[data-open-modal]').on('click', function(){
        console.log('open cd');
        $('#modal-export').toggleClass('active');
    });

    $('#export').on('click', function(){
        exportCsv();
    });

    $('#select-all').on('change', function(){
        $('[data-select-dealer]').attr('checked', $(this).is(':checked'));
    });

    if($('[data-capoarea-areas]').length){
        initArea();
    }

    $('[data-export-period]').each(function(){
        datePicker(this, moment().subtract(29, 'days'));
    });

    $('[data-dashboard-period]').each(function(){
        datePicker(this, moment(), "MM/YYYY", true);
    });

    $('[data-customer-export]').each(function(){
        var params = new URL(document.location).searchParams;
        if($(this).val() == ''){
            $(this).val(params.get('id'));
        }
    });

    $('[data-export-orders]').on('change', function(){
        if($(this).is(':checked')){
            $('[data-export-dates]').css('display', 'block');
        } else {
            $('[data-export-dates]').css('display', 'none');
        }
    });

    $('[data-export-dashboard]').on('change', function(){
        if($(this).is(':checked')){
            $('[data-export-dashboards]').css('display', 'block');
        } else {
            $('[data-export-dashboards]').css('display', 'none');
        }
    });

    if($('[data-capoarea-dashboard]').length){
        getDealerData();
    }
    if($('[data-capoarea-order]').length){
        getDealerOrder();
    }

    $('[data-dashboard-export]').on('click', function(){
        downloadCSV('Dashboard', $(this).parents('form'));
    });

    $('[data-orders-export]').on('click', function(){
        downloadCSV('Ordini', $(this).parents('form'));
    });
}

function exportCsv(){
    if($('[data-export-dashboard]').is(':checked')){
        downloadCSV('Dashboard', '#export-form');
    }
    if($('[data-export-orders]').is(':checked')){
        downloadCSV('Ordini', '#export-form');
    }
}

function downloadCSV(type, form){
    var customers = [];
    $(form).find('[name="customers[]"]').each(function(){
        if($(this).attr('type') == 'checkbox'){
            if($(this).is(':checked')){
                customers.push($(this).val());
            }
        } else {
            customers.push($(this).val());
        }
        console.log($(this).val());
    });
    var dates = $(form).find('[data-export-period]').val().split(' - ');
    const data = new FormData($(form).get(0));
    const years =dates[1].split('/');
    var json = {
        'tipoEstrazione': type,
        'customers': customers,
        'seller': data.get('vendors') ? data.get('vendors') : '',
        'capoArea': 0,
        'dataInizio': dates[0],
        'dataFine': dates[1],
        'dataRiferimento': `01/${data.get('dataRiferimento') ? data.get('dataRiferimento') : years[years.length-1]}`,
    };
    console.log(json);
    
    fetch($(form).attr('action'), {
        body: JSON.stringify(json),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json; charset=utf-8'
        },
    })
    .then(response => {
        console.log(response);
        return response.blob();
    })
    .then(response => {
        console.log(response);
        const blob = new Blob([response], {type: 'application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        const downloadUrl = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = downloadUrl;
        var name = `${type}_${(json.dataInizio.replaceAll('/', '-'))}_${(json.dataFine.replaceAll('/', '-'))}.xlsx`;
        if(type == 'Dashboard'){
            name = `Dashboard_Rif${json.dataRiferimento.replaceAll('/', '-')}_Estr${moment().format('DD-MM-YYYY HH:mm:ss')}.xlsx`;
        }
        a.download = name;
        document.body.appendChild(a);
        a.click();
    })
}

 // Funzione per il download del PDF degli obiettivi
function downloadPdf(customer, token, head=null) {
    const url = `${LIB_URL}/api/Dealer/GetSalesReport/${customer}${head ? '?shopifyAreaHeadId='+head : ''}`;
    var filename = 'download';
    fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/pdf',
            'X-JLR-Token': token
        }
    })
    .then(response => {
        for (const pair of response.headers.entries()) {
            console.log(pair[0]+ ': '+ pair[1]);
        }
        const contentDisposition = response.headers.get('content-disposition');
        console.log(contentDisposition);
        filename = contentDisposition.split(';')[1].split('=')[1].replace(/"/g, '');
        if (!response.ok) {
            throw new Error('Errore nella richiesta: ' + response.statusText);
        }
        return response.blob();
    }) 
    .then((blob) => {
        if (blob.size === 0) {
            throw new Error('PDF vuoto ricevuto');
        }
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = downloadUrl;
        a.download = filename; 
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(downloadUrl);
        document.body.removeChild(a);
    }) 
    .catch(error => {
        console.error('Errore nel download del PDF:', error);
    });
}

function s2ab(s) {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
  }

function getDealerOrder(){
    var params = new URL(document.location).searchParams;
    var url = `${LIB_URL}/api/Dealer/GetOrder/${params.get('id')}`;
	$.ajax({
		type: 'GET',
		url: url,
		dataType: 'json',
		cache: false,
		contentType: false,
		processData: false,
		success: function (response) {
            orderData = response;
            console.log(orderData);
            showOrderData(); 
		},
		error: function (err) {
			console.log(err);
		}
	});
}

function showOrderData(){
    var tCanceled = $('#order-temp-canceled').text();
    var tProperties = $('#order-temp-properties').text();
    var tFulfillment = $('#order-temp-fulfillment').text();
    var tFulfillmentUrl = $('#order-temp-fulfillment-url').text();
    var tFulfillmentCarrier = $('#order-temp-fulfillment-carrier').text();
    var tLine = $('#order-temp-line').text();
    var tOrder = $('#order-temp').text();
    var frameNumber = orderData.orderHeader.frameNumber || 'Non disponibile';
    var address = [
        orderData.orderHeader.company,
        orderData.orderHeader.address1,
        orderData.orderHeader.zip+" "+orderData.orderHeader.city+" ("+orderData.orderHeader.province+")",
        orderData.orderHeader.countryName
    ];
    $('[data-capoarea-title]').text(orderData.orderHeader.company);
    $('[data-capoarea-back]').attr('href', '/account?view=dealer&orders=1&id='+orderData.orderHeader.shopifyCustomerID);

    var order = tOrder.replaceAll('{name}', orderData.orderHeader.shopifyOrderName)
                    .replaceAll('{created_formatted}', formatDate(orderData.orderHeader.createdAt))
                    .replaceAll('{created}', orderData.orderHeader.createdAt)
                    .replaceAll('{subtotal}', formatMoney(orderData.orderHeader.amount))
                    .replaceAll('{shippingprice}', formatMoney(orderData.orderHeader.shippingFee))
                    .replaceAll('{total}', formatMoney(orderData.orderHeader.amount))
                    .replaceAll('{frameNumber}', frameNumber) // Sostituzione del numero di telaio
                    .replaceAll('{address}', address.join('<br>'))
                    .replaceAll('{status}', orderData.orderHeader.orderStatus);

    if(orderData.orderHeader.cancelled_at != null && orderData.orderHeader.cancelled_at != 'null' && orderData.orderHeader.cancelled_at != 'undefined' && orderData.orderHeader.cancelled_at != undefined){
        var canc = tCanceled.replaceAll('{canceled}', orderData.orderHeader.cancelled_at)
                            .replaceAll('{canceled_formatted}', formatDate(orderData.orderHeader.cancelled_at))
                            .replaceAll('{motivation}', orderData.orderHeader.cancel_reason);
        order = order.replaceAll('{canceled_t}', canc);
    } else {
        order = order.replaceAll('{canceled_t}', ' ');
    }

    var lines = [];
    $(orderData.orderLines).each(function(){
        var lineobj = this;
        var line = tLine.replaceAll('{variantname}', this.title)
                        .replaceAll('{sku}', this.shopifySku)
                        .replaceAll('{price}', formatMoney(this.discountedPrice))
                        .replaceAll('{quantity}', this.orderQty)
                        .replaceAll('{liters}', this.orderLiters ? this.orderLiters*this.orderQty : '-')
                        .replaceAll('{lineprice}', formatMoney(this.discountedPrice*this.orderQty));
      
        if(this.properties != undefined && this.properties.length > 0){
            var props = [];
            $(this.properties).each(function(){
                var prop = tProperties.replaceAll('{key}', this.name)
                                    .replaceAll('{value}', this.value);
                props.push(prop);
            });
            line = line.replaceAll('{properties}', props.join(''));
        } else {
            line = line.replaceAll('{properties}', '');
        }

        if(this.fulfillments != undefined && this.fulfillments.length > 0){
            var fulfillments = [];
            $(this.fulfillments).each(function(){
                var fulfillment = this;
                $(this.line_items).each(function(){
                    if(this.id == lineobj.id){
                        var ff = tFulfillment.replaceAll('{delivery_date}', fulfillment.created_at)
                                            .replaceAll('{delivery_date_formatted}', formatDate(fulfillment.created_at));
                        if(fulfillment.tracking_url != undefined && fulfillment.tracking_url != null){
                            var url = tFulfillmentUrl.replaceAll('{tracking_url}', fulfillment.tracking_url);
                            ff = ff.replaceAll('{url}', url);
                        } else {
                            ff = ff.replaceAll('{url}', '');
                        }
                        if(fulfillment.tracking_company != undefined && fulfillment.tracking_company != null){
                            var carrier = tFulfillmentCarrier.replaceAll('{carrier}', fulfillment.tracking_company);
                            ff = ff.replaceAll('{carrier}', carrier);
                        } else {
                            ff = ff.replaceAll('{carrier}', '');
                        }
                        fulfillments.push(ff);
                    }
                });
            });
            line = line.replaceAll('{fulfillment}', fulfillments.join(''));
        } else {
            line = line.replaceAll('{fulfillment}', '');
        }
        lines.push(line);
    });
    order = order.replaceAll('{lines}', lines.join(''));
    
    $('[data-capoarea-order]').html(order);
}

function getDealerData(){
    var params = new URL(document.location).searchParams;
    $('[data-capoarea-dashboard]').attr('data-dashboard', params.get('id'));
    initDashboard($('[data-dashboard]'));
    initOrders(params.get('id'));

    $('[data-dashboard-link]').attr('href', '/account?view=dealer&id='+params.get('id'));
    $('[data-orders-link]').attr('href', '/account?view=dealer&orders=1&id='+params.get('id'));

    console.log('getDealerData');

    if(params.get('orders') != undefined){
        $('[data-dashboard-container]').css('display', 'none');
        $('[data-orders-container]').css('display', 'block');
    } else{
        $('[data-orders-container]').css('display', 'none');
        $('[data-dashboard-container]').css('display', 'block');
    }
}

function showAreaOrders(orders){
    var tOrder = $('#capoarea-orders').text();
    $('[data-capoarea-title]').text(orders.company);
    orders.orderHeaders.sort((a, b) => (a.createdAt < b.createdAt) ? 1 : -1);
    $(orders.orderHeaders).each(function(){
        var date = formatDate(this.createdAt);
        var o = tOrder.replaceAll('{id}', this.shopifyOrderID);
        o = o.replaceAll('{name}', this.shopifyOrderName);
        o = o.replaceAll('{stamp}', this.createdAt);
        o = o.replaceAll('{date}', date);
        o = o.replaceAll('{status}', this.orderStatus);
        o = o.replaceAll('{total}', formatMoney(this.amount));
        $('[data-capoarea-orders]').append(o);
    });
}

function formatDate(date, format="DD-MM-YYYY"){
    return moment(date).format(format);
}

function formatMoney(amount){
    const a = parseFloat(amount).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return window.currencyFormat.replace('{{amount}}', a).replace('{{amount_with_comma_separator}}', a);
}

function initOrders(id){
    var url = `${LIB_URL}/api/Dealer/GetOrders?shopifyCustomerId=${id}`;
	$.ajax({
		type: 'GET',
		url: url,
		dataType: 'json',
		cache: false,
		contentType: false,
		processData: false,
		success: function (response) {
            console.log(response);
            orders = response;
            showAreaOrders(orders);
		},
		error: function (err) {
			console.log(err);
		}
	});
}

function showArea(check){
    var checks = $('[data-capoarea-area]:checked');
    var ids = [];
    $(checks).each(function(){
        ids.push($(this).val());
    });

    $('[data-capoarea-areacont]').each(function(){
        var id = $(this).attr('data-capoarea-areacont');
        if(ids.indexOf(id) >= 0){
            $(this).css('display', 'block');
            $(this).find('[data-select-dealer]').attr('disabled', false);
        } else {
            $(this).css('display', 'none');
            $(this).find('[data-select-dealer]').attr('checked', false).attr('disabled', true);
        }
    });

    $('[data-capoarea-areacont]').css('display', 'none');
    $(ids).each(function(){
        $('[data-capoarea-areacont="'+this+'"]').css('display', 'block');
    });
    
}

function showData(){
    var areaList = $('[data-capoarea-areas]');
    var areaDealers = $('[data-capoarea-dealers]');

    var tList = $('#area-check').text();
    var tDealers = $('#area').text();
    var tDealer = $('#dealer').text();

    $(capoareaData).each(function(){
        var l = tList.replaceAll('{id}', handleize(this.Area));
        l = l.replaceAll('{title}', this.Area);
        $(areaList).append(l);

        var d = tDealers.replaceAll('{id}', handleize(this.Area));
        d = d.replaceAll('{title}', this.Area);
        var ds = [];

        $(this.Customer).each(function(){
            var t = tDealer.replaceAll('{id}', this.ShopifyCustomerID);
            t = t.replaceAll('{title}', this.Company);
            ds.push(t);
        });
        d = d.replaceAll('{dealers}', ds.join(''));
        $(areaDealers).append(d);
    });
}

function initArea(){
    var id = $('[data-capoarea-dealers]').attr('data-capoarea-dealers');
    var url = `${LIB_URL}/api/Dealer/GetDealers/${id}`;
	$.ajax({
		type: 'GET',
		url: url,
		dataType: 'json',
		cache: false,
		contentType: 'application/json',
		processData: false,
		success: function (response) {
            console.log(response);
            capoareaData = response;
            showData();
		},
		error: function (err) {
			console.log(err);
		}
	});
}

function customFields(){
    $('[data-product-custom]').on('click', function(){
        $('#modal-custom').toggleClass('active');
    });

    var form = new validateForm($('#modal-custom'), {});
    form.setOptions({
        sendingMsg: 'Salvo le informazioni...',
        successMsg: 'Ok, aggiunto!',
        onSubmit: function(data){
            Swal.fire({
                text: this.sendingMsg,
                showConfirmButton: false,
            });
            var productForm = new validateForm($('[data-type="add-to-cart-form"]'), {});
            productForm.init();
            form.formData = productForm.getData(new FormData());
            form.formData = form.getData(form.formData);
            form.submitForm();
        },
        onSuccessAlertClose: function (data) {
            location.reload();
        }
    });
    form.init();
}

function cart(){
    if($('#cart').length){
        const cartForm = new validateForm($('#cart'), {
            sendingMsg: "Attendere...",
            onSubmit: () =>  {
                $('#cart').append('<input type="hidden" name="checkout" value="1">');
                $('#cart').trigger('submit');
            },
        }).init();
    }
}

function orderlist(){
    var ordersTable = '#orders-table';
    if($(ordersTable).length){
        initOrders();
    }

    function initOrders(){
        var orders = [];
        var content;
        var offset = 0;
        var tot = 0;
        var num = 10;

        renderTable();
        checkOrder();

        function renderTable(){
            $(ordersTable).html(table);
            content = $(ordersTable).find('[data-orders-table]');
            getOrders(showOrders);
        }

        function getOrders(callback){
            console.log('getOrders');
            orders = [];
            var json = {
                "Total": 33,
                "Elements": [
                    {
                        "VendorOrderId": "OC/2023/3333",
                        "JLROrderReference": "XXXXXX",
                        "CustomerOrderReference": "CL/2023/56787",
                        "IsExternal": true,
                        "ChannelId": "AGENCY",
                        "CustomerId": "1703",
                        "CustomerAddressId": "8703",
                        "RegistrationDate": "2023-03-27",
                        "InvoiceStatus": "P",
                        "FulfillmentStatus": "Y",
                        "Value": 323456.13,
                        "ShippingAddress": "Via armando diaz, 33, Arzignano, 36071 Italia"
                    },
                    {
                        "VendorOrderId": "OC/2023/4444",
                        "JLROrderReference": "1057-3",
                        "CustomerOrderReference": "CLI/2023/35555",
                        "IsExternal": false,
                        "ChannelId": "JLR-OFFICIAL-SHOP",
                        "CustomerId": "1703",
                        "CustomerAddressId": "8703",
                        "RegistrationDate": "2023-04-13",
                        "InvoiceStatus": "N",
                        "FulfillmentStatus": "P",
                        "Value": 0.0,
                        "ShippingAddress": null
                    },
                    {
                        "VendorOrderId": "OC/2023/3333",
                        "JLROrderReference": "XXXXXX",
                        "CustomerOrderReference": "CL/2023/56787",
                        "IsExternal": true,
                        "ChannelId": "AGENCY",
                        "CustomerId": "1703",
                        "CustomerAddressId": "8703",
                        "RegistrationDate": "2023-03-27",
                        "InvoiceStatus": "P",
                        "FulfillmentStatus": "Y",
                        "Value": 323456.13,
                        "ShippingAddress": "Via armando diaz, 33, Arzignano, 36071 Italia"
                    },
                    {
                        "VendorOrderId": "OC/2023/4444",
                        "JLROrderReference": "1057-3",
                        "CustomerOrderReference": "CLI/2023/35555",
                        "IsExternal": false,
                        "ChannelId": "JLR-OFFICIAL-SHOP",
                        "CustomerId": "1703",
                        "CustomerAddressId": "8703",
                        "RegistrationDate": "2023-04-13",
                        "InvoiceStatus": "N",
                        "FulfillmentStatus": "P",
                        "Value": 0.0,
                        "ShippingAddress": null
                    },
                    {
                        "VendorOrderId": "OC/2023/3333",
                        "JLROrderReference": "XXXXXX",
                        "CustomerOrderReference": "CL/2023/56787",
                        "IsExternal": true,
                        "ChannelId": "AGENCY",
                        "CustomerId": "1703",
                        "CustomerAddressId": "8703",
                        "RegistrationDate": "2023-03-27",
                        "InvoiceStatus": "P",
                        "FulfillmentStatus": "Y",
                        "Value": 323456.13,
                        "ShippingAddress": "Via armando diaz, 33, Arzignano, 36071 Italia"
                    },
                    {
                        "VendorOrderId": "OC/2023/4444",
                        "JLROrderReference": "1057-3",
                        "CustomerOrderReference": "CLI/2023/35555",
                        "IsExternal": false,
                        "ChannelId": "JLR-OFFICIAL-SHOP",
                        "CustomerId": "1703",
                        "CustomerAddressId": "8703",
                        "RegistrationDate": "2023-04-13",
                        "InvoiceStatus": "N",
                        "FulfillmentStatus": "P",
                        "Value": 0.0,
                        "ShippingAddress": null
                    },
                    {
                        "VendorOrderId": "OC/2023/3333",
                        "JLROrderReference": "XXXXXX",
                        "CustomerOrderReference": "CL/2023/56787",
                        "IsExternal": true,
                        "ChannelId": "AGENCY",
                        "CustomerId": "1703",
                        "CustomerAddressId": "8703",
                        "RegistrationDate": "2023-03-27",
                        "InvoiceStatus": "P",
                        "FulfillmentStatus": "Y",
                        "Value": 323456.13,
                        "ShippingAddress": "Via armando diaz, 33, Arzignano, 36071 Italia"
                    },
                    {
                        "VendorOrderId": "OC/2023/4444",
                        "JLROrderReference": "1057-3",
                        "CustomerOrderReference": "CLI/2023/35555",
                        "IsExternal": false,
                        "ChannelId": "JLR-OFFICIAL-SHOP",
                        "CustomerId": "1703",
                        "CustomerAddressId": "8703",
                        "RegistrationDate": "2023-04-13",
                        "InvoiceStatus": "N",
                        "FulfillmentStatus": "P",
                        "Value": 0.0,
                        "ShippingAddress": null
                    },
                    {
                        "VendorOrderId": "OC/2023/3333",
                        "JLROrderReference": "XXXXXX",
                        "CustomerOrderReference": "CL/2023/56787",
                        "IsExternal": true,
                        "ChannelId": "AGENCY",
                        "CustomerId": "1703",
                        "CustomerAddressId": "8703",
                        "RegistrationDate": "2023-03-27",
                        "InvoiceStatus": "P",
                        "FulfillmentStatus": "Y",
                        "Value": 323456.13,
                        "ShippingAddress": "Via armando diaz, 33, Arzignano, 36071 Italia"
                    },
                    {
                        "VendorOrderId": "OC/2023/4444",
                        "JLROrderReference": "1057-3",
                        "CustomerOrderReference": "CLI/2023/35555",
                        "IsExternal": false,
                        "ChannelId": "JLR-OFFICIAL-SHOP",
                        "CustomerId": "1703",
                        "CustomerAddressId": "8703",
                        "RegistrationDate": "2023-04-13",
                        "InvoiceStatus": "N",
                        "FulfillmentStatus": "P",
                        "Value": 0.0,
                        "ShippingAddress": null
                    }
                ]
            };
            tot = json.Total;
            offset = offset + json.Elements.length;
            orders = json.Elements;
            callback();
        }

        function showOrders(){
            var rows = [];
            $(orders).each(function(i){
                var temp = row.replaceAll('{index}', i)
                                .replaceAll('{total}', getPrice(this.Value))
                                .replaceAll('{purchased_location}', this.ChannelId)
                                .replaceAll('{fulfillment_status}', getFulfillment(this.FulfillmentStatus))
                                .replaceAll('{financial_status}', getPayment(this.InvoiceStatus))
                                .replaceAll('{date}', this.RegistrationDate)
                                .replaceAll('{name}', this.CustomerOrderReference);
                rows.push(temp);
            });
            $(content).append(rows.join(''));
            if(offset < tot){
                $(ordersTable).find('[data-orders-pagination-container]').html(pagination);
                $(ordersTable).find('[data-orders-pagination]').on('click', function(){
                    getOrders(showOrders);
                });
            } else {
                $(ordersTable).find('[data-orders-pagination-container]').html('');
            }
            $(ordersTable).find('[data-order]').on('click', function(){
                var id = $(this).attr('data-order');
                openOrder(id);
            });
        }

        function openOrder(id){
            const params = new URLSearchParams(window.location.search);
            params.set('CustomerOrderReference', id);
            window.history.replaceState({}, "", decodeURIComponent(`${window.location.pathname}?${params}`));
            getOrder(id);
        }

        function getOrder(id){
            var order = { 
                "Header" : {
                    "VendorOrderId": "OC/2023/3333",
                    "JLROrderReference": "XXXXXX",
                    "CustomerOrderReference": "CL/2023/56787",
                    "IsExternal": true,
                    "ChannelId": "AGENCY",
                    "CustomerId": "1703",
                    "CustomerAddressId": "8703",
                    "RegistrationDate": "2023-03-27",
                    "InvoiceStatus": "P",
                    "FulfillmentStatus": "Y",
                    "Value": 323456.13,
                    "ShippingAddress": "Via armando diaz, 33, Arzignano, 36071 Italia"
                },
                "Lines": [
                    {
                        "LineId": 1,
                        "ProductName": "Test titolo prodotto",
                        "ProductCode": "KSE123456",
                        "Quantity": 23,
                        "Uom": null,
                        "UnitPrice": 10.45,
                        "DeliveredQuantity": 23,
                        "InvoicedQuantity": 23,
                        "IsClosed": true
                    },
                    {
                        "LineId": 2,
                        "ProductName": "Test titolo prodotto",
                        "ProductCode": "TGE AD345667",
                        "Quantity": 55,
                        "Uom": null,
                        "UnitPrice": 3.42,
                        "DeliveredQuantity": 55,
                        "InvoicedQuantity": 50,
                        "IsClosed": false
                    },
                    {
                        "LineId": 3,
                        "ProductName": "Test titolo prodotto",
                        "ProductCode": "WER AAC78900",
                        "Quantity": 150,
                        "Uom": null,
                        "UnitPrice": 5.67,
                        "DeliveredQuantity": 100,
                        "InvoicedQuantity": 100,
                        "IsClosed": true
                    },
                    {
                        "LineId": 4,
                        "ProductName": "Test titolo prodotto",
                        "ProductCode": "QUE AA68780",
                        "Quantity": 200,
                        "Uom": null,
                        "UnitPrice": 1.78,
                        "DeliveredQuantity": 200,
                        "InvoicedQuantity": 200,
                        "IsClosed": true
                    }
                ]
            };
            showOrder(order);
        }

        function checkOrder(){
            const params = new URLSearchParams(window.location.search);
            var id = params.get('CustomerOrderReference');
            if(id != undefined){
                getOrder(id);
            }
        }

        function showOrder(order){
            var lines = [];
            $(order.Lines).each(function(i){
                console.log(i);
                lines.push(line.replaceAll('{title}', this.ProductName)
                                .replaceAll('{sku}', this.ProductCode) 
                                .replaceAll('{unitPrice}', getPrice(this.UnitPrice))
                                .replaceAll('{quantity}', this.InvoicedQuantity)
                                .replaceAll('{liters}', this.orderLiters ? this.orderLiters*this.InvoicedQuantity : '-') // sostituire con i litri quando enrico fa modifica
                                .replaceAll('{price}', getPrice(this.InvoicedQuantity*this.UnitPrice)));
            });
            var m = modal.replaceAll('{name}', order.Header.CustomerOrderReference)
                        .replaceAll('{date}', order.Header.RegistrationDate)
                        .replaceAll('{payment_status}', getPayment(order.Header.InvoiceStatus))
                        .replaceAll('{fulfillment_status}', getFulfillment(order.Header.FulfillmentStatus))
                        .replaceAll('{shipping_address}', order.Header.ShippingAddress)
                        .replaceAll('{lines}', lines.join(''))
                        .replaceAll('{total}', getPrice(order.Header.Value));
            $('body').append(m);
            $('.btn-close').on('click', function(){
                $('.modal').remove();
                const params = new URLSearchParams(window.location.search);
                params.delete('CustomerOrderReference');
                window.history.replaceState({}, "", decodeURIComponent(`${window.location.pathname}?${params}`));
            });
        }

        function getPayment(payment){
            return translations.payment_statuses[payment];
        }

        function getFulfillment(fulfillment){
            return translations.fulfillment_statuses[fulfillment];
        }

        function getPrice(price){
            return ('€'+price.toFixed(2)).replace('.', ',');
        }
    }
}

function setDashboard(){
    if($('[data-dashboard]').length){
        initDashboard($('[data-dashboard]').first());
    }
}

function initDashboard(el){
	var customer = $(el).attr('data-dashboard');
	var url = `${LIB_URL}/api/Dashboard/${customer}?dataRiferimento=${moment().format('DD/MM/YYYY')}`;
    const picker = $('[data-dashboard-period]').first();
    $(picker).on('apply.daterangepicker', function(e, picker) {
        var url = `${LIB_URL}/api/Dashboard/${customer}?dataRiferimento=${picker.startDate.format('DD/MM/YYYY')}`;
        getData(url, el);
    });
	getData(url, el);
}
	
function getData(url, el){
	$.ajax({
		type: 'GET',
		url: url,
		dataType: 'json',
		cache: false,
		contentType: false,
		processData: false,
		success: function (response) {
            console.log(response);
        	showDashboard(response.elements, el);
		},
		error: function (err) {
			console.log(err);
		}
	});
}

function showDashboard(data, el){
	var boxes = [];
    var order = ['Pirelli', 'Continental', 'Castrol', 'Würth', 'Azotal', 'CO.RA. S.p.A.', 'Getrasped', 'Genart', 'Ricambi JLR'];
    $(order).each(function(){
        var o = this;
        $(data).each(function(){
            if(o == this.vendor){
                var s = this.vendor == 'Castrol' ? ' lt' : '';
                var t = this.vendor == 'Azotal' || this.vendor == 'CO.RA.' || this.vendor == 'Würth' || this.vendor == 'Getrasped' || this.vendor == 'Ricambi JLR' ? dashboard : dashboardE;
                boxes.push(t.replaceAll('{title}', this.vendor)
                            .replaceAll('{current_month}', formatQTY(this.quantityCurrentMonth, s))
                            .replaceAll('{current_month_eur}', formatMoney(this.valueCurrentMonth))
                            .replaceAll('{previous_month}', formatQTY(this.quantityPreviousMonth, s))
                            .replaceAll('{previous_month_eur}', formatMoney(this.valuePreviousMonth))
                            .replaceAll('{current_quarter}', formatQTY(this.quantityCurrentQuarter, s))
                            .replaceAll('{current_quarter_eur}', formatMoney(this.valueCurrentQuarter))
                            .replaceAll('{current_year_eur}', formatMoney(this.valueCurrentYear))
                            .replaceAll('{current_year}', formatQTY(this.quantityCurrentYear, s))); 
            }
        });
    });
	$(el).html(boxes.join(''));
    $('[data-download-pdf]').on('click', function(e) {
        e.preventDefault();
        const customer = $(this).data('download-area') != undefined ? new URLSearchParams(window.location.search).get('id') : $(this).data('download-pdf');
        const token = $(this).data('download-pdf-token');
        const head = $(this).data('download-pdf');
        downloadPdf(customer, token, head);
    });
}
  
function formatQTY(num, suffix=""){
    return num+suffix;
}

function cartInput(){
    $('.cart-item-quantity-wrapper .quantity-input-minus').on('click',function(){
        $(this).parents('form').trigger('submit');
    });
    $('.cart-item-quantity-wrapper .quantity-input-plus').on('click',function(){
        $(this).parents('form').trigger('submit');
    });
    $('.cart-item-quantity-wrapper [name="updates[]"]').on('keyup',function(){
        $(this).parents('form').trigger('submit');
    });
    // $('.cart-item-quantity-wrapper .button-cart-remove').on('click',function(){
    //     $(this).parents('form').trigger('submit');
    // });
}

function minQty(){
    $('input[min]').on('blur', function(){
        try {
            var val = Number($(this).val());
            var min = Number($(this).attr('min'));
            if(val < min){
                $(this).val(min);
            }
        } catch {}
    });
    $('input[max]').on('blur', function(){
        try {
            var val = Number($(this).val());
            var min = Number($(this).attr('max'));
            if(val > min){
                $(this).val(min);
            }
        } catch {}
    });
}

function handleize(name){
  if(name != undefined && name != null)
    return name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
  else
    return ''
}

function datePicker(input, start, format="DD/MM/YYYY", single=false){
    var min = parseInt($(input).attr('data-input-date-min'));
    var max = parseInt($(input).attr('data-input-date-max'));
    
    var opt = {
        singleDatePicker: single,
        timePicker: false,
        showDropdowns: true,
        minDate: moment(min * 1000),
        maxDate: moment(max * 1000),
        startDate: start,
        endDate: moment(),
        showDropdowns: true,
        autoApply: true,
        locale: {
            format: format,
            separator: " - ",
            applyLabel: "Applica",
            cancelLabel: "Annulla",
            fromLabel: "Da",
            toLabel: "A",
            customRangeLabel: "Personalizzato",
            weekLabel: "W",
            daysOfWeek: ["Do", "Lu", "Ma", "Me", "Gi", "Ve", "Sa"],
            monthNames: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
            firstDay: 1,
            cancelLabel: 'Rimuovi',
        },
    }
    $(input).daterangepicker(opt);
    $(input).on('cancel.daterangepicker', function(ev, picker) {
        //do something, like clearing an input
        $(input).val('');
      });
}